<template>
  <transition name="component-fade" mode="out-in">
    <!-- <keep-alive> -->
      <component
         v-bind:is="activeChart"
         class="nuttrema--measurements-graph"
        :chartDetails="chartDetails"
        :measurementDetails="measurementDetails"
        :measurements="state.data.chart"
        :trackable="trackable">
      </component>
    <!-- </keep-alive> -->
  </transition>
</template>

<script>
import { isEmpty, isNull } from 'lodash';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import ChartBodyComponents from './charts/chart-body-components';
import ChartMetabolicRates from './charts/chart-metabolic-rates';
import ChartWeightStructure from './charts/chart-weight-structure';
import ChartMorphometricsWaistHipRatio from './charts/chart-morphometrics-waist-hip-ratio';
import ChartBodyVitalsHeartRespiratoryRates from './charts/chart-body-vitals-heart-respiratory-rates';
import ChartBodyVitalsBloodPressureGlucose from './charts/chart-body-vitals-blood-pressure-glucose';
import ChartBodyVitalsBodyTemperature from './charts/chart-body-vitals-body-temperature';

export default {
  name: 'cmpt-measurements-graph',
  props: {
    state: {
      type: Object,
      required: true,
      default: null,
    },
    activeChart: {
      required: true,
      default: null,
    },
    chartDetails: {
      required: false,
      default: null,
    },
    measurementDetails: {
      required: false,
      default: null,
    },
    trackable: {
      required: false,
      default: null,
    },
  },
  components: {
    ChartBodyComponents,
    ChartMorphometricsWaistHipRatio,
    ChartMetabolicRates,
    ChartWeightStructure,
    ChartBodyVitalsBloodPressureGlucose,
    ChartBodyVitalsHeartRespiratoryRates,
    ChartBodyVitalsBodyTemperature,
    NuttremaLoader,
    NuttremaEmptyResult,
  },
  computed: {
    isEmpty() {
      return isNull(this.state.error) && isEmpty(this.state.data.chart) && !this.state.fetching && this.state.fetched;
    },
    isLoading() {
      return isNull(this.state.error) && this.state.fetching && !this.state.fetched;
    },
  },
};
</script>

<style lang="scss" scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }

  .nuttrema--measurements-graph {
    flex-grow: 1;
    display: flex;
    position: relative;
    align-self: stretch;
    padding: 0.75em 0;
    background-color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/cmpt-measurements-graph.vue